import { InsightsData } from '../../types/campaign'

export const filterEmptyAndSort = (data: InsightsData[]): InsightsData[] =>
  data.filter(({ value }) => !!value).sort(({ value: a }, { value: b }) => b - a)
